import request from 'utils/request'

// Prodcut Types
const fetchProductType = (id, options = {}) =>
  request(`product-types/${id}/`, {
    ...options,
  })
const createProductType = (options = {}) =>
  request('product-types/', {
    method: 'POST',
    ...options,
  })
const updateProductType = (id, options = {}) =>
  request(`product-types/${id}/`, {
    method: 'PUT',
    ...options,
  })
const deleteProductType = (id, options = {}) =>
  request(`product-types/${id}/`, {
    method: 'DELETE',
    ...options,
  })
const fetchProductTypes = (options = {}) => request('product-types/', { ...options })

// Delivery Duty
const fetchDeliveryDuty = (id, options = {}) =>
  request(`admin/delivery-duty-settings/${id}/`, {
    ...options,
  })
const createDeliveryDuty = (options = {}) =>
  request('admin/delivery-duty-settings/', {
    method: 'POST',
    ...options,
  })
const updateDeliveryDuty = (id, options = {}) =>
  request(`admin/delivery-duty-settings/${id}/`, {
    method: 'PUT',
    ...options,
  })
const deleteDeliveryDuty = (id, options = {}) =>
  request(`admin/delivery-duty-settings/${id}/`, {
    method: 'DELETE',
    ...options,
  })
const fetchDeliveryDuties = (options = {}) =>
  request('admin/delivery-duty-settings/', { ...options })

// Memberships
const fetchMemberships = (options = {}) => request('admin/membership-plans', { ...options })
const updateMembership = (id, options = {}) =>
  request(`admin/membership-plans/${id}`, { method: 'PUT', ...options })
const fetchMembershipFeatures = (options = {}) =>
  request('admin/membership-features', { ...options })
const updateMembershipFeature = (id, options = {}) =>
  request(`admin/membership-features/${id}`, { method: 'PUT', ...options })
const createMembershipFeature = (options = {}) =>
  request('admin/membership-features/', { method: 'POST', ...options })

// Warehouses
const fetchWarehouses = (options = {}) => request('admin/warehouses', { ...options })
const updateWarehouse = (id, options = {}) =>
  request(`admin/warehouses/${id}`, { method: 'PUT', ...options })
const createWarehouse = (options = {}) =>
  request('admin/warehouses/', { method: 'POST', ...options })

// Custom Links
const fetchCustomLinks = (options = {}) => request('admin/custom-links', { ...options })
const updateCustomLink = (id, options = {}) =>
  request(`admin/custom-links/${id}`, { method: 'POST', ...options })
const deleteCustomLink = (id, options = {}) =>
  request(`admin/custom-links/${id}`, { method: 'DELETE', ...options })
const createCustomLink = (options = {}) =>
  request('admin/custom-links/', { method: 'POST', ...options })

// Courier Vendors
const fetchCourierVendors = (options = {}) => request('admin/courier-vendors', { ...options })
const updateCourierVendor = (id, options = {}) =>
  request(`admin/courier-vendors/${id}`, { method: 'PUT', ...options })
const createCourierVendor = (options = {}) =>
  request('admin/courier-vendors/', { method: 'POST', ...options })

export {
  fetchWarehouses,
  updateWarehouse,
  createWarehouse,
  fetchProductType,
  createProductType,
  fetchProductTypes,
  deleteProductType,
  updateProductType,
  fetchDeliveryDuties,
  deleteDeliveryDuty,
  updateDeliveryDuty,
  createDeliveryDuty,
  fetchDeliveryDuty,
  fetchMemberships,
  updateMembership,
  fetchMembershipFeatures,
  updateMembershipFeature,
  createMembershipFeature,
  fetchCustomLinks,
  updateCustomLink,
  createCustomLink,
  deleteCustomLink,
  fetchCourierVendors,
  updateCourierVendor,
  createCourierVendor,
}
